import axios from "axios";
import {TTP_API_URL} from "Config";
import { updateSourceToken, throwCatchedError } from 'utils';


let fetchDocumentsSourceToken;
let fetchAssignmentsSourceToken;
let fetchNotPaidInvoicesSourceToken;

export const getFacturationStatistics = (token, app, appRef, issuerId, year,appType, sourceToken=null) => {


  fetchDocumentsSourceToken = updateSourceToken(fetchDocumentsSourceToken, sourceToken);

  const requestUrl = `${TTP_API_URL}/billing/document/sum-count-by-event-and-descr`;
  return axios.get(requestUrl, {
    cancelToken: fetchDocumentsSourceToken.token,
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      // app,
      appRef,
      issuerId,
      year,
      appType
    }
  })
};

export const getPaymentStatistics = (token, app, appRef, issuerId, year,appType, sourceToken=null) => {

  fetchAssignmentsSourceToken = updateSourceToken(fetchAssignmentsSourceToken, sourceToken);

  const requestUrl = `${TTP_API_URL}/billing/assignment/sum-amount-by-event`;
  return axios.get(requestUrl, {
    cancelToken: fetchAssignmentsSourceToken.token,
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      // app,
      appRef,
      issuerId,
      year,
      appType
    }
  })
};

export const getNotPaidInvoices = (token, app, appRef , issuerId, year,appType, sourceToken=null) => {

  fetchNotPaidInvoicesSourceToken = updateSourceToken(fetchNotPaidInvoicesSourceToken, sourceToken);


  const requestUrl = `${TTP_API_URL}/billing/document/sum-count-invoice-by-event`;
  return axios.get(requestUrl, {
    cancelToken: fetchNotPaidInvoicesSourceToken.token,
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      // app,
      appRef,
      issuerId,
      year,
      appType
    }
  })
};

export const getRecapByDay = (token, app, appRef, operationType, issuerId, year, appType) => {

  const requestUrl = `${TTP_API_URL}/billing/assignment/sum-amount-by-event-and-day`;
  return axios.get(requestUrl, {
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      app,
      appRef,
      operationType,
      issuerId,
      year,
      appType
    }
  })
};

export const getInvoiceByEventDetails = (token, app, appRef, operationType, day, issuerId, year, appType) => {

  const requestUrl = `${TTP_API_URL}/billing/invoice/get-paid-invoice-by-operation-type`;
  return axios.get(requestUrl, {
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      app,
      appRef,
      operationType,
      day,
      issuerId,
      year,
      appType
    }
  })
};


export const getUnpaidInvoicesDetails = (token, app, appRef, issuerId, year, appType) => {

  const requestUrl = `${TTP_API_URL}/billing/invoice/get-not-paid-invoice`;
  return axios.get(requestUrl, {
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      app,
      appRef,
      issuerId,
      year,
      appType
    }
  })
};

export const displayCsvFile = (token, app, appRef, operationType, day, search, issuerId, year, appType) => {

  const requestUrl = TTP_API_URL+`/billing/invoice/get-csv-paid-invoice-by-operation-type`;

  const fileName = 'invoices_'+operationType+ (day !== null ? '_'+day+'.csv' : '.csv');

  return axios.get(requestUrl, {
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      app,
      appRef,
      operationType,
      day,
      search,
      issuerId,
      year,
      appType
    },
    responseType: 'blob'
  }).then((response) => {
    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
    var fileLink = document.createElement('a');

    fileLink.href = fileURL;
    fileLink.setAttribute('download', fileName);
    document.body.appendChild(fileLink);

    fileLink.click();
  });
};

export const displayNotPaidInvoicesCsvFile = (token, app, appRef, search, issuerId, year, appType) => {

  const requestUrl = TTP_API_URL+`/billing/invoice/get-csv-not-paid-invoice-by-operation-type`;

  const fileName = 'not-paid-invoices_'+app.join('-')+(appRef !== [] ? '_'+appRef.join('-')+'.csv' : '.csv');

  return axios.get(requestUrl, {
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      app,
      appRef,
      search,
      issuerId,
      year,
      appType
    },
    responseType: 'blob'
  }).then((response) => {
    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
    var fileLink = document.createElement('a');

    fileLink.href = fileURL;
    fileLink.setAttribute('download', fileName);
    document.body.appendChild(fileLink);
    fileLink.click();
  });
};

export const displayRecapPaymentCsvFile = (token, app, appRef, operationType, date, issuerId, year, appType) => {

  const requestUrl = TTP_API_URL+`/billing/assignment/get-csv-file-by-operation-type`;

  const fileName = 'recap-payment_'+app.join('-')+'_'+operationType+(appRef !== [] ? '_'+appRef.join('-')+'.csv' : '.csv');

  return axios.get(requestUrl, {
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      app,
      appRef,
      operationType,
      date,
      issuerId,
      year,
      appType
    },
    responseType: 'blob'
  }).then((response) => {
    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
    var fileLink = document.createElement('a');

    fileLink.href = fileURL;
    fileLink.setAttribute('download', fileName);
    document.body.appendChild(fileLink);
    fileLink.click();
  });
};

export const displayPdfPaidInvoicesFile = (token, app, appRef, operationType, day, search, issuerId, year, appType) => {

  const requestUrl = TTP_API_URL+`/billing/invoice/get-pdf-paid-invoice-by-operation-type`;

  const fileName = 'paid-invoices_'+operationType+ '_'+app.join('-')+(appRef !== [] ? '_'+appRef.join('-') : '')+ (day !== null ? '_'+day+'.pdf' : '.pdf');

  return axios.get(requestUrl, {
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      app,
      appRef,
      operationType,
      day,
      search,
      issuerId,
      year,
      appType
    },
    responseType: 'blob'
  }).then((response) => {
    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
    var fileLink = document.createElement('a');

    fileLink.href = fileURL;
    fileLink.setAttribute('download', fileName);
    document.body.appendChild(fileLink);

    fileLink.click();
  });
};

export const displayNotPaidInvoicesPdfFile = (token, app, appRef, search, issuerId, year, appType) => {

  const requestUrl = TTP_API_URL+`/billing/invoice/get-pdf-not-paid-invoice-by-operation-type`;

  const fileName = 'not-paid-invoices_'+app.join('-')+(appRef !== [] ? '_'+appRef.join('-')+'.pdf' : '.pdf');

  return axios.get(requestUrl, {
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      app,
      appRef,
      search,
      issuerId,
      year,
      appType
    },
    responseType: 'blob'
  }).then((response) => {
    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
    var fileLink = document.createElement('a');

    fileLink.href = fileURL;
    fileLink.setAttribute('download', fileName);
    document.body.appendChild(fileLink);
    fileLink.click();
  });
};

export const displayRecapPaymentPdfFile = (token, app, appRef, operationType, date, issuerId, year, appType) => {

  const requestUrl = TTP_API_URL+`/billing/assignment/get-pdf-file-by-operation-type`;

  const fileName = 'recap-payment_'+app.join('-')+'_'+operationType+(appRef !== [] ? '_'+appRef.join('-')+'.pdf' : '.pdf');

  return axios.get(requestUrl, {
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      app,
      appRef,
      operationType,
      date,
      issuerId,
      year,
      appType
    },
    responseType: 'blob'
  }).then((response) => {
    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
    var fileLink = document.createElement('a');

    fileLink.href = fileURL;
    fileLink.setAttribute('download', fileName);
    document.body.appendChild(fileLink);
    fileLink.click();
  });
};

export const getDocumentsToBeExportedZipEfff = (token, app, appRef, issuerId, year, discriminant, appType) => {

  const requestUrl = `${TTP_API_URL}/billing/document/get-invoices-creditNotes-to-be-exported-zip-efff`;
  return axios.get(requestUrl, {
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      app,
      appRef,
      issuerId,
      year,
      discriminant,
      appType
    }
  })
};

export const startCommandExportEfffZip = (token, app, appRef, issuerId, year, discriminant, zipType, appType, isXml) => {

  const requestUrl = `${TTP_API_URL}/billing/document/start-command-export-efff-zip`;

  if(isXml == undefined)
    isXml = 0;

  return axios.get(requestUrl, {
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      app,
      appRef,
      issuerId,
      year,
      discriminant,
      zipType,
      appType,
      isXml,
    }
  })
};

export const getCommandInfo = (token, commandId) => {
  const requestUrl = `${TTP_API_URL}/event/command/`+commandId;
  return axios.get(requestUrl, {
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
    }
  })
};

let fetchDoubleAssignmentsSourceToken ;
export const getDoublePayment = (token, app, appRef, issuerId, year, appType, sourceToken=null) => {

  fetchDoubleAssignmentsSourceToken = updateSourceToken(fetchDoubleAssignmentsSourceToken, sourceToken);

  const requestUrl = `${TTP_API_URL}/billing/document/get-double-payment`;
  return axios.get(requestUrl, {
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    cancelToken: fetchDoubleAssignmentsSourceToken.token,
    params: {
      access_token: token,
      app,
      appRef,
      issuerId,
      year,
      appType
    }
  })
};



// WEBPACK FOOTER //
// ./app/api/TamtamAPI/statistics.js